<template lang="pug">
  b-container#affiliation-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col
        h4.mb-1 Cuenta de cobros
        p.text-secondary Tu cuenta de cobros es donde depositaremos el dinero de tus ventas. Registra tu cuenta en
          b.mx-1 menos de 3 minutos
          span y empieza a recibir pagos con tarjetas de crédito y débito.

      b-card.no-shadow.card-inactive
        check-square-icon.icon-md.text-success.mr-2
        span Al continuar y crear tu Cuenta de cobros aceptas nuestra
        b-link.mx-1(href="/politica-privacidad", target="_blank") Política de privacidad
        span y nuestros
        b-link.mx-1(href="/terminos-condiciones", target="_blank") Términos y condiciones

      b-card.no-shadow.w-100.bg-light(v-if="pragaStatus")
        h4(v-if="pragaStatus.registerComplete") Tu registro está completo
        h4(v-else) Aún no se ha completado tu registro
        div.mt-3(v-if="pragaStatus.bankAccount")
          h5 {{ pragaStatus.bankAccount.account }}
          p.text-bold {{ pragaStatus.bankAccount.bankAccount }}
          .d-flex.algin-items-center
            span Estado: {{ pragaStatus.bankAccount.validationStateDescription }}


    //- b-row.mb-5
    //-   b-col.text-center.mb-3.mb-md-0(md="6")
    //-     validation-provider(:rules="{ required: { allowFalse: false } }", name="Política de privacidad", v-slot="{ valid, errors }")
    //-       b-form-group
    //-         label.text-secondary Política de privacidad *
    //-         b-form-checkbox(v-model="privacy_policy", :state="errors[0] ? false : (valid ? true : null)") Acepto la
    //-           b-link.ml-2(href="/politica-privacidad", target="_blank") Política de privacidad
    //-             external-link-icon.icon-sm.ml-2.mb-1
    //-         span.text-sm.text-danger {{errors[0]}}
    //-   b-col.text-center.mb-3.mb-md-0(md="6")
    //-     validation-provider(:rules="{ required: { allowFalse: false } }", name="Términos y condiciones", v-slot="{ valid, errors }")
    //-       b-form-group
    //-         label.text-secondary Términos y condiciones *
    //-         b-form-checkbox(v-model="terms_conditions", :state="errors[0] ? false : (valid ? true : null)") Acepto los
    //-           b-link.ml-2(href="/terminos-condiciones", target="_blank") Términos y condiciones
    //-             external-link-icon.icon-sm.ml-2.mb-1
    //-         span.text-sm.text-danger {{errors[0]}}

    b-card
      b-row.pointer(v-b-toggle.personal-data)
        b-col
          h5.mb-0.d-flex.align-items-center
            check-circle-icon.mr-2.text-success(v-if="account.merchant_id")
            alert-circle-icon.mr-2.text-warning(v-else)
            span Datos personales
        b-col(cols="auto")
          chevron-down-icon.text-secondary
      b-collapse.pt-5(id="personal-data")
        validation-observer(ref="person_observer", v-slot="{ invalid, dirty, handleSubmit, errors }")
          b-form(@submit.prevent="handleSubmit(updateOrCreate)")
            // TYPE SELECTION
            h5.uppercase Tipo de persona
            b-form-group.mb-5
              b-form-radio-group(v-model="pragaForm.taxType", vid="personType", stacked)
                b-form-radio(value="PF") Persona física
                b-form-radio(value="PM") Persona moral
            // PF
            b-alert.mb-5(variant="info", :show="pragaForm.taxType == 'PM'")
              alert-circle-icon.icon-sm.mr-2
              span La información personal y de contacto corresponden al representante legal
            h5.uppercase Datos personales
            b-row.mb-5
              b-col(md="6")
                validation-provider(:rules="{alpha_spaces: true, required: true}", name="Nombre", v-slot="{ valid, errors, validated }")
                  b-form-group(label-for="_name")
                    label.text-secondary Nombre *
                    b-form-input#_name(v-model.trim="pragaForm.name", placeholder="Nombre", :state="errors[0] ? false : (valid ? true : null)" autocomplete="given-name")
                    b-form-invalid-feedback {{errors[0]}}
              b-col(md="6")
                b-form-group(label-for="_middleName")
                  label.text-secondary Segundo nombre
                  b-form-input#_middleName(v-model.trim="pragaForm.middleName", placeholder="Segundo nombre", :state="pragaForm.middleName ? true : null" autocomplete="additional-name")
              b-col(md="6")
                validation-provider(:rules="{alpha_spaces: true, required: true}", name="Apellido paterno", v-slot="{ valid, errors, validated }")
                  b-form-group(label-for="_lastName")
                    label.text-secondary Apellido paterno *
                    b-form-input#_lastName(v-model.trim="pragaForm.lastName", placeholder="Apellido paterno", :state="errors[0] ? false : (valid ? true : null)" autocomplete="family-name")
                    b-form-invalid-feedback {{errors[0]}}
              b-col(md="6")
                validation-provider(:rules="{alpha_spaces: true, required: true}", name="Apellido materno", v-slot="{ valid, errors, validated }")
                  b-form-group(label-for="_mothersName")
                    label.text-secondary Apellido materno *
                    b-form-input#_mothersName(v-model.trim="pragaForm.mothersName", placeholder="Apellido materno", :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                    b-form-invalid-feedback {{errors[0]}}
              //b-col(md="6")
                label.text-secondary Fecha de nacimiento *
                b-form-row
                  b-col(cols="4")
                    validation-provider(:rules="{required: true}", name="Día", v-slot="{ valid, errors, validated }")
                      b-form-group
                        label.text-secondary Día
                        b-form-select(v-model="day", :options="generateDays()", :state="errors[0] ? false : (valid ? true : null)")
                  b-col(cols="4")
                    validation-provider(:rules="{required: true}", name="Mes", v-slot="{ valid, errors, validated }")
                      b-form-group
                        label.text-secondary Mes
                        b-form-select(v-model="month", :options="generateMonths()", :state="errors[0] ? false : (valid ? true : null)")
                  b-col(cols="4")
                    validation-provider(:rules="{required: true}", name="Día", v-slot="{ valid, errors, validated }")
                      b-form-group
                        label.text-secondary Año
                        b-form-select(v-model="year", :options="generateYears()", :state="errors[0] ? false : (valid ? true : null)")

            // PHONE
            h5.uppercase Datos de contacto
            b-row.mb-5
              b-col(md="6")
                validation-provider(rules="required|email" name="Email" v-slot="{ valid, errors }")
                  b-form-group(label-for="_email")
                    label.text-secondary Email *
                    b-form-input#_email(v-model.trim="pragaForm.email", type="email", placeholder="Email", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="email")
                    b-form-invalid-feedback {{errors[0]}}
              b-col(md="6")
                validation-provider(rules="required|digits:10" name="Celular" v-slot="{ valid, errors }")
                  b-form-group(label-for="_cellPhone")
                    label.text-secondary.w-100 Celular *
                    b-form-input#_cellPhone(v-model.trim="pragaForm.cellPhone", type="number", placeholder="Número celular", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="tel")
                    b-form-invalid-feedback {{errors[0]}}

            // ADDRESS
            h5.uppercase Domicilio
            p.text-secondary A continuación ingresa tu dirección en el cuadro de búsqueda y la información será autocompletada por Google.
            b-form-group.mb-3(description="Al escribir aparecerán opciones similares a tu texto. Powered by Google.")
              b-input-group
                b-form-input(placeholder="Escribe la dirección a buscar...", v-model="address_search", id="search_autocomplete", autocomplete="off", @focus="$event.target.select()", :state="errors[0] ? false : null")
                b-input-group-append
                  b-input-group-text
                    search-icon.icon-sm
            p.text-help(v-if="addressInputsLocked") Si la búsqueda no te funciona, puedes
              b-link.ml-2(@click="addressInputsLocked = false") llenar los datos manualmente
            b-alert(:show="addressFromMap", variant="warning")
              alert-circle-icon.icon-sm.mr-2
              span Completa los Datos Personales antes de continuar
            validation-observer(ref="address_form")
              fieldset(:disabled="addressInputsLocked")
                b-row.mb-5
                  b-col(md="12")
                    validation-provider(rules="required" name="Calle" v-slot="{ valid, errors }")
                      b-form-group(label-for="_street")
                        label.text-secondary Calle *
                        b-form-input#_street(v-model.trim="pragaForm.street", placeholder="Calle", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="street-address")
                        b-form-invalid-feedback {{errors[0]}}
                  b-col(md="4")
                    validation-provider(rules="required|max:10" name="Numero exterior" v-slot="{ valid, errors }")
                      b-form-group(label-for="_externalNumber")
                        label.text-secondary Numero exterior *
                        b-form-input#_externalNumber(v-model.trim="pragaForm.externalNumber", placeholder="Num. ext.", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                        b-form-invalid-feedback {{errors[0]}}
                  b-col(md="4")
                    validation-provider(rules="max:10" name="Numero exterior" v-slot="{ valid, errors }")
                      b-form-group(label-for="_internalNumber")
                        label.text-secondary Numero interior
                        b-form-input#_internalNumber(v-model.trim="pragaForm.internalNumber", placeholder="Num. int.", :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                        b-form-invalid-feedback {{errors[0]}}
                  b-col(md="4")
                    validation-provider(rules="required|numeric|min:5" name="Código postal" v-slot="{ valid, errors }")
                      b-form-group(label-for="_zip_code")
                        label.text-secondary Código postal *
                        b-form-input#_zip_code(v-model.trim="pragaForm.zipCode", type="number", placeholder="CP", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="postal-code")
                        b-form-invalid-feedback {{errors[0]}}
                  //b-col(md="12")
                    b-form-group(label-for="_colony")
                      label.text-secondary Colonia
                      b-form-select#_colony(v-model="pragaForm.colony", :disabled="!locations.length", @change="colonyChanged", required, :state="pragaForm.colony ? null : (validated ? false : null)")
                        option(value="", disabled) {{locations.length ? '-- Seleccionar colonia --' : '-- Ingresa código postal --'}}
                        option(v-for="(location, index) in locations", :key="index", :value="location.colony") {{location.colony}}
                  b-col(md="6")
                    validation-provider(rules="required" name="Colonia" v-slot="{ valid, errors }")
                      b-form-group(label-for="_colony")
                        label.text-secondary Colonia *
                        b-form-input#_colony(v-model.trim="pragaForm.colony", placeholder="Colonia", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                        b-form-invalid-feedback {{errors[0]}}
                  b-col(md="6")
                    validation-provider(rules="required" name="Municipio" v-slot="{ valid, errors }")
                      b-form-group(label-for="_municipality")
                        label.text-secondary Municipio *
                          b-spinner.ml-2(small, variant="primary" v-if="loadingColony")
                        b-form-input#_municipality(v-model.trim="pragaForm.municipality", placeholder="Municipio", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                        b-form-invalid-feedback {{errors[0]}}
                  //b-col(md="6")
                  //  validation-provider(rules="required" name="Ciudad" v-slot="{ valid, errors }")
                  //    b-form-group(label-for="_city")
                  //      label.text-secondary Ciudad *
                  //      b-form-input#_city(v-model.trim="pragaForm.city", placeholder="Ciudad", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                  //      b-form-invalid-feedback {{errors[0]}}
                  b-col(md="6")
                    validation-provider(rules="required" name="Estado" v-slot="{ valid, errors }")
                      b-form-group(label-for="_state")
                        label.text-secondary Estado *
                        b-form-input#_state(v-model.trim="pragaForm.state", placeholder="Estado", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                        b-form-invalid-feedback {{errors[0]}}

            p.text-center.text-danger(v-if="invalid && dirty") Completa los campos obligatorios
            b-button(block, variant="primary", type="submit") Actualizar datos

    b-card
      b-row.pointer(v-b-toggle.banking-data)
        b-col
          h5.mb-0.d-flex.align-items-center
            check-circle-icon.mr-2.text-success(v-if="pragaStatus && Boolean(pragaStatus.stepId) && pragaStatus.stepId >= 5")
            alert-circle-icon.mr-2.text-warning(v-else)
            span Datos bancarios
        b-col(cols="auto")
          chevron-down-icon.text-secondary
      b-collapse.pt-5(id="banking-data")
        b-alert(:show="!account.merchant_id", variant="warning")
          alert-circle-icon.icon-sm.mr-2
          span Completa los Datos Personales antes de continuar
        validation-observer(v-show="account.merchant_id", ref="person_observer", v-slot="{ invalid, handleSubmit, errors }")
          b-form(@submit.prevent="handleSubmit(updateOrCreate)")

            h5.uppercase(v-show="pragaForm.taxType == 'PM'") Datos de la empresa
            // COMPANY DATA
            b-row.mb-5(v-if="pragaForm.taxType == 'PM'")
              b-col(md="6")
                validation-provider(:rules="{alpha_spaces: true, required: pragaForm.taxType == 'PM'}" name="Nombre comercial" v-slot="{ valid, errors }")
                  b-form-group(label-for="_commercialName", description="Nombre público de la empresa")
                    label.text-secondary Nombre comercial *
                    b-form-input#_commercialName(v-model="pragaForm.commercialName", placeholder="Nombre comercial", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                    b-form-invalid-feedback {{errors[0]}}
              b-col(md="6")
                validation-provider(:rules="{alpha_spaces: true, required: pragaForm.taxType == 'PM'}" name="Razón social" v-slot="{ valid, errors, validated }")
                  b-form-group(label-for="_officialName", description="Nombre oficial registrado de la empresa")
                    label.text-secondary Razón social *
                    b-form-input#_officialName(v-model.trim="pragaForm.officialName", placeholder="Razón social", :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                    b-form-invalid-feedback {{errors[0]}}

            // BILLING
            h5.uppercase Información bancaria
            b-row.mb-5
              b-col(md="12")
                validation-provider(rules="required|digits:18|numeric" name="Clabe" v-slot="{ valid, errors }")
                  b-form-group(label-for="_clabe")
                    label.text-secondary Clabe bancaria (18 dígitos) *
                    b-input-group
                      b-form-input#_clabe(v-model.trim="pragaForm.bankAccount", type="number", placeholder="Clabe", required, :state="errors[0] ? false : (valid ? valid_clabe : null)" autocomplete="off")
                      b-input-group-append(v-if="loading")
                        b-input-group-text
                          b-spinner(small, variant="primary", type="grow")
                    b-form-invalid-feedback(:state="correct_clabe || loading ? null : false") {{ pragaForm.bankAccount.length >= 18 ? 'Clabe invalida' : errors[0] }}
                    //- b-form-valid-feedback(:state="valid_clabe") {{bank_name}}
              b-col(md="6", v-if="pragaForm.taxType == 'PM'")
                validation-provider(:rules="{required:true,alpha_num:true,min:10,max:13}" name="RFC" v-slot="{ valid, errors }")
                  b-form-group(label-for="_RFC")
                    label.text-secondary RFC *
                    b-form-input#_RFC(:value="pragaForm.rfc", @input="pragaForm.rfc = $event.toUpperCase()", placeholder="RFC", required, :state="errors[0] ? false : (valid ? true : null)" autocomplete="off")
                    b-form-invalid-feedback {{errors[0]}}
              b-col(md="6", v-if="pragaForm.taxType == 'PM'")
                b-form-group.mt-4(label-for="_billing")
                  b-form-checkbox#_billing(:checked="parseBoolean(pragaForm.requiresBilling)", @change="pragaForm.requiresBilling = $event", required) Requiere factura

            p.text-center.text-danger(v-if="invalid") Completa los campos obligatorios
            b-button(block, variant="primary", type="submit") Actualizar datos

    b-card
      b-row.pointer(v-b-toggle.docs-data)
        b-col
          h5.mb-0.d-flex.align-items-center
            check-circle-icon.mr-2.text-success(v-if="pragaStatus && pragaStatus.stepId >= 6")
            alert-circle-icon.mr-2.text-warning(v-else)
            span Sube tus documentos
        b-col(cols="auto")
          chevron-down-icon.text-secondary
      b-collapse.pt-5(id="docs-data")
        b-alert(:show="!pragaStatus || !Boolean(pragaStatus.stepId) || pragaStatus.stepId < 5", variant="warning")
          alert-circle-icon.icon-sm.mr-2
          span Completa tus Datos Bancarios antes de continuar.
        validation-observer(ref="person_observer", v-slot="{ invalid, handleSubmit, errors }")
          b-form(@submit.prevent="handleSubmit(updateData)")
            // FILES
            h5.uppercase.mb-2 Documentos oficiales
            p.text-secondary.mb-4 Puedes subir imágenes en formato JPG, PNG o archivos PDF
            b-alert.mb-4(:show="pragaStatus && pragaStatus.stepId >= 6" variant="info")
              b-form-row
                b-col(cols="auto")
                  alert-triangle-icon
                b-col
                  p.mb-0 Ya has subido tus documentos. Solo de ser necesario, puedes actualizar tus documentos subiéndolos de nuevo aquí.
            p.mb-1.uppercase Identificación oficial
            b-row.mb-3
              b-col.my-2(md="12")
                validation-provider(rules="required", name="Identificación oficial - FRENTE" v-slot="{ valid, errors }")
                  b-form-group
                    label.text-secondary Identificación oficial (solo frente es requerido)
                    b-form-file(id="ineFile", accept="image/*, .pdf",  placeholder="No se ha subido archivo", browse-text="Adjuntar", drop-placeholder="Suelta los archivos aquí", v-model="ineFile", :state="errors[0] ? false : (valid && pragaForm.ineFile ? true : null)", @input="loadFile('ineFile', $event)")
                    b-form-invalid-feedback {{errors[0]}}

            //- p.mb-1.uppercase Comprobante de domicilio
            //- b-row.mb-3
            //-   b-col.my-2(md="12")
            //-     validation-provider(rules="required", name="Comprobante de domicilio" v-slot="{ valid, errors }")
            //-       b-form-group
            //-         label.text-secondary Comprobante de domicilio no mayor a 3 meses
            //-         b-form-file(id="addressIdFile", accept="image/*, .pdf", placeholder="No se ha subido archivo", browse-text="Adjuntar", drop-placeholder="Suelta los archivos aquí", v-model="addressIdFile", :state="errors[0] ? false : (valid && pragaForm.addressIdFile ? true : null)", @input="loadFile('addressIdFile', $event)")
            //-         b-form-invalid-feedback {{errors[0]}}

            p.mb-1.uppercase Estado de cuenta
            b-row.mb-5
              b-col.my-2(md="12")
                validation-provider(rules="required", name="Estado de cuenta" v-slot="{ valid, errors }")
                  b-form-group
                    label.text-secondary Carátula de tu estado de cuenta no mayor a 3 meses
                    b-form-file(id="accountStateFile", accept="image/*, .pdf", placeholder="No se ha subido archivo", browse-text="Adjuntar", drop-placeholder="Suelta los archivos aquí", v-model="accountStateFile", :state="errors[0] ? false : (valid && pragaForm.accountStateFile ? true : null)", @input="loadFile('accountStateFile', $event)")
                    b-form-invalid-feedback {{errors[0]}}

            div.my-3(v-if="savingPragaData")
              p.mb-1 Subiendo archivos:
              b-progress(variant="primary" :value="100" striped animated)

            p.text-center.text-danger(v-if="invalid") Completa los campos obligatorios
            b-button(block, variant="primary", type="submit" :disabled="savingPragaData") Actualizar datos

    b-alert.mb-5.text-center(variant="secondary", show, id="feeAlert") Todas las ventas generan una comisión
      help-circle-icon.icon-md.text-info.pointer(id="feeTooltip")
      b-link.ml-2(href="/Contrato_BIX.pdf", target="_blank") Términos y condiciones
        external-link-icon.icon-sm.ml-2.mb-1

    b-tooltip.text-left(container="feeAlert" target="feeTooltip" triggers="hover focus")
      p.mb-1 Konverza Free:
        span.font-weight-bold.ml-2 8% + IVA
      p.mb-0 Konverza Pro:
        span.font-weight-bold.ml-2 3.5% + IVA
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const accountController = createNamespacedHelpers('account')
  import Validators from '@/helpers/data_validators';

  import { EventBus } from '@/helpers/eventBus'
  import { toBase64 } from '@/helpers/file-converter'
  window.initPlaces = function () {
    EventBus.$emit('places_loaded')
  }

  export default {
    mixins: [Validators.Methods],
    data () {
      return {
        loadingColony: false,
        loading: false,
        addressInputsLocked: true,
        addressFromMap: false,
        address_search: '',
        locations: [],
        correct_clabe: false,
        bank_name: '',
        ineFile: null,
        ineBackFile: null,
        accountStateFile: null,
        addressIdFile: null,
        privacy_policy: true,
        terms_conditions: true,
        day: null,
        month: null,
        year: null,
        savingPragaData: false,
        place_fields: {
          street_number: 'short_name',
          route: 'long_name',
          locality: 'long_name',
          sublocality_level_1 : 'long_name',
          administrative_area_level_1: 'long_name',
          country: 'long_name',
          postal_code: 'short_name'
        },
        pragaForm: {
          taxType: 'PF',

          name: '',
          middleName: '',
          lastName: '',
          mothersName: '',
          birthDate: '',
          email: '',
          rfc: '',
          requiresBilling: false,

          officialName: '',

          commercialName: '',

          bankAccount: '',

          phoneNumber: '',
          phoneExtension: '',
          cellPhone: '',

          street: '',
          externalNumber: '',
          internalNumber: '',
          zipCode: '',
          colony: '',
          municipality: '',
          city: '',
          state: '',
          ineFile: null,
          ineBackFile: null,
          addressIdFile: null,
          accountStateFile: null
        },
        pragaStatus: null
      }
    },
    computed: {
      ...accountController.mapState({
        account: state => state.account
      }),
      valid_clabe () {
        return this.correct_clabe && this.pragaForm.bankAccount.length >= 18 && !this.loading
      },
      birthDate () {
        return this.day + '/' + this.month + '/' + this.year
      },
      special_partner () {
        return this.getCurrentUser().partner_id == '87'
      }
    },
    methods: {
      ...mapActions(['helpers/zip_code', 'helpers/validate_clabe', 'account/getPraga', 'merchant/get', 'merchant/pragaUpdate', 'account/get', 'account/pragaStatus', 'account/praga']),
      generateDays () {
        let array = [
          {
            value: null,
            text: 'DD',
            disabled: true
          }
        ]

        for (let i = 1; i < 32; i++) {
          let text = i < 10 ? ('0' + i) : i.toString()
          array.push({
            value: text,
            text: text
          })
        }

        return array
      },
      generateMonths () {
        let array = [
          {
            value: null,
            text: 'MM',
            disabled: true
          }
        ]

        for (let i = 1; i < 13; i++) {
          let text = i < 10 ? ('0' + i) : i.toString()
          array.push({
            value: text,
            text: text
          })
        }

        return array
      },
      generateYears () {
        let array = [
          {
            value: null,
            text: 'AA',
            disabled: true
          }
        ]
        let year = parseInt(this.$moment().format('YYYY'))

        for (let i = 1920; i <= year; i++) {
          let text = i.toString()
          array.push({
            value: text,
            text: text
          })
        }

        return array
      },
      getLocations () {
        let self = this
        this.loadingColony = true
        this['helpers/zip_code']({
          zipcode: self.pragaForm.zipCode,
          callback: res => {
            this.loadingColony = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.locations = res.resource.map(el => {
                return {
                  colony: el.d_asenta,
                  municipality: el.D_mnpio,
                  state: el.d_estado,
                  city: el.d_ciudad
                };
              });

              if (self.locations.length) {
                this.colonyChanged(self.locations[0].colony)
              }
            }
          }
        })
      },
      getBankInfo () {
        this.loading = true
        let self = this

        this['helpers/validate_clabe']({
          clabe: self.pragaForm.bankAccount,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.bank_name = res.resource.tag
              self.correct_clabe = res.resource.ok
            }
          }
        })
      },
      colonyChanged (colony) {
        let location = this.locations.find(l => l.colony == colony)
        //this.pragaForm.colony = location.colony
        if (location) {
          this.pragaForm.municipality = location.municipality
          this.pragaForm.state = location.state
          this.pragaForm.city = location.city
        }
      },
      async sendData () {
        let self = this
        this.showLoadingScreen()
        this.savingPragaData = true

        this['account/praga']({
          account_id: self.$route.params.account_id,
          ...self.pragaForm,
          callback: res => {
            this.savingPragaData = false
            self.hideLoadingScreen()
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Cuenta de cobros creada correctamente')
              setTimeout(function () {
                window.location.reload()
              }, 1000);
            }
          }
        })
      },
      async updateData (showLoader) {
        let self = this
        if (showLoader === true)
          this.showLoadingScreen()
        this.savingPragaData = true

        this['merchant/pragaUpdate']({
          account_id: self.$route.params.account_id,
          merchant_id: self.account.merchant_id,
          ...self.pragaForm,
          callback: res => {
            this.savingPragaData = false
            self.hideLoadingScreen()
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Cuenta de cobros actualizada')
              this.getMerchantPragaData()
              this.getPragaStatus()
            }
          }
        })
      },
      async getMerchantPragaData () {
        let self = this

        this.addressInputsLocked = false
        this['account/getPraga']({
          account_id: self.$route.params.account_id,
          callback: res => {
            if (res != undefined) {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                for (let key in this.pragaForm) {
                  if (res[key]) {
                    if (key == 'birthDate') {
                      let bday = res.resource[key].split('/')
                      this.day = bday[0]
                      this.month = bday[1]
                      this.year = bday[2]
                    } else {
                      this.pragaForm[key] = res[key]
                    }
                  }
                }
              }
            } else {

            }
          }
        })
      },
      async getPragaStatus () {
        let self = this

        this['account/pragaStatus']({
          account_id: self.$route.params.account_id,
          callback: res => {
            console.log(res);
            if (res != undefined) {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                this.pragaStatus = res
              }
            } else {

            }
          }
        })
      },
      getAccount () {
        let self = this

        return new Promise(resolve => {
          this['account/get']({
            account_id: self.$route.params.account_id,
            callback: res => {
              resolve(res.resource)
            }
          })
        })
      },
      parseBoolean (value) {
        return value != undefined ? (value == 1 || value == '1' || value == true || value == 'true') : false
      },
      updateOrCreate () {
        if (this.account.merchant_id) {
          this.updateData(true)
        } else {
          this.sendData()
        }
      },
      async loadFile (name, file) {
        if (file && file.size) {
          if (file.size > 1024 * 1024 * 2) {
            this.$bvModal.msgBoxOk('El peso del archivo no debe exceder los 2MB.', {
              okVariant: 'primary',
              okTitle: 'Entendido',
              centered: true
            }).then(done => {
              this.pragaForm[name] = null
              this[name] = null
            }).catch(() => {})
            return
          } else if (!this.validFile(file)) {
            this.$bvModal.msgBoxOk('Solo puedes subir archivos PDF o imagenes.', {
              okVariant: 'primary',
              okTitle: 'Entendido',
              centered: true
            }).then(done => {
              this.pragaForm[name] = null
              this[name] = null
            }).catch(() => {})
            return
          }
        } else {
          this.$message.error('Archivo no válido. Intenta de nuevo')
          this.pragaForm[name] = null
          this[name] = null
          return
        }

        try {
          let fileBase64 = await toBase64(file)
          this.pragaForm[name] = fileBase64
        } catch (e) {
          console.log(e);
          this.pragaForm[name] = null
          this[name] = null
          this.$message.error('Error cargando archivo')
        }
      },
      validFile  (file) {
        try {
          if (file.name.includes('.')) {
            let regex = /(pdf|jpe?g|tiff|png|webp|bmp)$/i
            let file_extension = file.name.split('.').slice(-1)
            return regex.test(file_extension[0])
          }  if (file.type) {
            let regex = /\/(pdf|jpe?g|tiff|png|webp|bmp)$/i
            return regex.test(file.type)
          }
        } catch (e) {
          console.log(e.message)
        }
        return false
      },
      checkAccountType () {
        let isEcommerce = (new RegExp('^konverza-ecommerce', 'i')).test(this.account.type)
        if (!isEcommerce) {
          this.$router.push({name: 'Billing'}).catch(()=>{});
        }
      }
    },
    mounted () {
      let self = this

      var script = document.createElement('script')
      script.type = 'text/javascript'
      script['data-name'] = 'maps-api'
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo&libraries=places&callback=initPlaces&language=es'
      document.getElementsByTagName('head')[0].appendChild(script)

      EventBus.$on('places_loaded', () => {
        let autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('search_autocomplete'),
          {types: ['geocode', 'establishment']}
        )

        autocomplete.addListener('place_changed', () => {
          this.addressInputsLocked = false
          this.addressFromMap = true
          let place = autocomplete.getPlace()

          for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            switch (addressType) {
              case 'route':
                this.pragaForm.street = place.address_components[i][this.place_fields[addressType]]
                break
              case 'street_number':
                this.pragaForm.externalNumber = place.address_components[i][this.place_fields[addressType]]
                break
              case 'postal_code':
                this.pragaForm.zipCode = place.address_components[i][this.place_fields[addressType]]
                break
              case 'sublocality_level_1':
                this.pragaForm.colony = place.address_components[i][this.place_fields[addressType]]
                break
              case 'locality':
                this.pragaForm.city = place.address_components[i][this.place_fields[addressType]]
                break
              case 'administrative_area_level_1':
                this.pragaForm.state = place.address_components[i][this.place_fields[addressType]]
                break
            }
          }

          this.getLocations()

          this.$nextTick(() => {
            this.$refs.address_form.validate()
          })
        })
      })

      this.checkAccountType()
      this.getMerchantPragaData()
      this.getPragaStatus()
    },
    beforeDestroy () {
      EventBus.$off('places_loaded')
    },
    watch: {
      'pragaForm.bankAccount' (val) {
        this.pragaForm.bankAccount = val
        if (val.length >= 18) {
          this.getBankInfo()
        }
      },
      birthDate (value) {
        this.pragaForm.birthDate = value
      },
      account () {
        this.checkAccountType()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
